import { SelfServiceError } from '@/Services/BKAPI/Errors/SelfServiceError';
import { TicketHolder } from '@/Services/BKAPI/models';
import { SelfServiceTicketHolderResponse } from '@bookingkit/api-v4';

export const fromAPITicketHolder = (
  ticketHolderResponse: SelfServiceTicketHolderResponse
): TicketHolder => {
  const { id, ticket_id, data } = ticketHolderResponse;
  if (id == null) {
    throw SelfServiceError.fromMissingProperty('id', 'string', id);
  }
  if (typeof id !== 'string') {
    throw SelfServiceError.fromInvalidProperty('id', id);
  }
  if (typeof ticket_id !== 'string') {
    throw SelfServiceError.fromInvalidProperty('ticket_id', ticket_id);
  }

  if (data == null) {
    throw SelfServiceError.fromMissingProperty('data', 'TicketHolderResponseData', data);
  }
  if (typeof data !== 'object') {
    throw SelfServiceError.fromInvalidProperty('data', data);
  }

  const parseDob = (value: unknown): Date | null => {
    if (typeof value !== 'string') return null;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  };

  return {
    id,
    ticketId: ticket_id,
    data: {
      email: data.email ?? '',
      firstName: data.first_name ?? '',
      lastName: data.last_name ?? '',
      dateOfBirth: parseDob(data.date_of_birth),
      city: data.city ?? '',
      country: data.country ?? '',
      zip: data.zip ?? '',
      streetName: data.street_name ?? '',
      streetNumber: data.street_number ?? '',
    },
  };
};
